module.exports = __webpack_public_path__ + "img/2-2.341d8bc9.jpg";